import React from 'react';
import { Section, SectionTitle } from '../Section';
import { CTAButton } from '../CTAButton';
import { ModuleIcon } from '../ModuleIcon';
import { modules } from '../../data/landing';
export function ModulesSection() {
  return <Section tone="wine" data-id="element-102" data-mp="2ot4gn7oqawdq">
      <SectionTitle data-id="element-103" data-mp="2opqd3w4bwh4p">4 módulos. 2 horas. Una huella que no se borra.</SectionTitle>
      <p className="mt-6 text-[17px] leading-relaxed text-ivory/85 md:text-lg" data-id="element-104" data-mp="2tqe6gog15a23">
        Anatomía, técnica y ritmo, explicados paso a paso por la DOC.
      </p>

      <div className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-105" data-mp="211gxjbxpkpm0">
        {modules.map(m => <article key={m.number} className="flex flex-col rounded-2xl border border-gold/45 bg-ink p-7" data-id="element-106" data-mp="260tj7tcufqn0">
            <ModuleIcon name={m.icon} data-id="element-107" data-mp="2asjv43rfimgj" />
            <p className="mt-6 text-[13px] font-medium uppercase tracking-[0.2em] text-gold" data-id="element-108" data-mp="2atmqoozp5d2s">MÓDULO {m.number}</p>
            <h3 className="mt-2 font-serif text-[1.75rem] font-medium leading-tight text-ivory" data-id="element-109" data-mp="1dajukonw52mw">{m.title}</h3>
            <p className="mt-3 text-base leading-relaxed text-ivory/80" data-id="element-110" data-mp="1i9eejtxlgx8l">{m.text}</p>
          </article>)}
        <article className="rounded-2xl bg-gold p-7 text-ink md:col-span-2" data-id="element-111" data-mp="19qdljlqt2ezx">
          <h3 className="font-serif text-[1.75rem] font-semibold leading-tight" data-id="element-112" data-mp="19sgf2fr62q9e">Sesión de preguntas y respuestas.</h3>
          <p className="mt-2 text-base leading-relaxed text-ink/85" data-id="element-113" data-mp="10y1sds4b4dg9">
            Pregunta lo que nunca te atreviste a preguntar. 100% anónimas.
          </p>
        </article>
      </div>

      <div className="mt-14 text-center" data-id="element-114" data-mp="vwm8w4hs2ezz">
        <CTAButton data-id="element-115" data-mp="qzm9gcffoahu" />
      </div>
    </Section>;
}